import type { ColumnsType } from 'antd/es/table';

import type { ColumnBuilderParams, DataBuilderParams } from '@/features/(charts)/chart-renderer/ui/Cross/types';

import { MultiSeriesColumnBuilder } from '../builders';
import { MultiSeriesDataGenerator } from '../generators';
import type { ICrossTableStrategy } from './ICrossTableStrategy';

/**
 * 다중 시리즈 Strategy
 * 다중 시리즈 모드의 컬럼과 데이터 소스를 생성
 */
export class MultiSeriesStrategy implements ICrossTableStrategy {
  private columnBuilder: MultiSeriesColumnBuilder;
  private dataGenerator: MultiSeriesDataGenerator;

  constructor(
    columnParams: ColumnBuilderParams,
    dataParams: DataBuilderParams,
  ) {
    this.columnBuilder = new MultiSeriesColumnBuilder(columnParams);
    this.dataGenerator = new MultiSeriesDataGenerator(dataParams);
  }

  /**
   * 다중 시리즈 컬럼 생성
   */
  buildColumns(): ColumnsType<any> {
    return this.columnBuilder.buildColumns();
  }

  /**
   * 다중 시리즈 데이터 소스 생성
   */
  buildDataSource(): Record<string, StringNumberValue | null>[] {
    return this.dataGenerator.buildDataSource();
  }
}
